import { inject } from 'vue';
import type { EventBus } from '@/app/utils/eventBus';

export const eventBusProvideKey = 'eventBus';

/**
 * Injects the event bus so that it can be used in a composition API component.
 * In options API, the event bus can be accessed via the globalproperty with `this.$bus`.
 * @example
 * <script setup lang="ts">
 * import useEventBus from '@/utils/useEventBus';
 * const bus = useEventBus();
 *
 * onMounted(() => {
 *  bus.$on('validate', () => validate());
 * });
 * </script>
 * @returns
 */
export default function useEventBus() {
  const bus = inject<EventBus>(eventBusProvideKey);
  if (!bus) {
    throw new Error(
      'eventBus does not exist. Check that it is provided in the root component with app.provide(eventBusProvideKey, eventBus).'
    );
  }

  return bus;
}
